/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_In_UseInputs */



/**

* @param {Email_In_UseInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const email_in_use = /** @type {((inputs?: Email_In_UseInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_In_UseInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Diese Email wird bereits verwendet.")
});